import React from "react";
import { MFile, MInput, MLabel, ValidatedForm } from "components/forms";
import { dateHelper, payloadBuilder } from "libs";

export class RinunciaRiconoscimentoEstero extends ValidatedForm {
  emptyFields = {
    dataPresentazioneDomanda: "",
    istitution: "",
    numProtocollo: "",
    contactName: "",
    contactFax: "",
    contactPhone: "",
    contactEmail: "",
    contactPec: "",
  };

  constructor(props) {
    super(props);

    // bind event handler to invoke it from the child component
    this.onChange = this.onChange.bind(this);
  }

  state = {
    ...this.emptyFields,
    defaultValues: {
      ...this.emptyFields,
    },
    validationError: "",
  };

  FIELDS_GROUP = [
    [
      {
        id: "rinunciaLabel",
        field: "rinunciaLabel",
        infoText:
          "Rinuncia all'istanza di riconoscimento per la quale, alla data del 24 aprile 2025, siano decorsi i termini di conclusione del relativo procedimento e/o del contenzioso giurisdizionale per mancata adozione, da parte dell'amministrazione, di un provvedimento espresso.",
        component: MLabel,
        className: "col-md-12",
      },
    ],
    [
      {
        id: "istitution1",
        field: "istitution",
        label: "Sede giurisdizionale",
        component: MInput,
        className: "col-md-6",
      },

      {
        id: "numProtocollo",
        field: "numProtocollo",
        label: "Protocollo n.",
        component: MInput,
        className: "col-md-6",
      },
      {
        id: "dataPresentazioneDomanda1",
        field: "dataPresentazioneDomanda",
        label: "Data di rinuncia",
        infoText: "(data limite indicabile 16 marzo 2026)",
        component: MInput,
        type: "date",
        className: "col-md-6",
      },
    ],
    [
      {
        field: "rinunciaRiconoscimentoLabel",
        label: "Rinuncia all'istanza di riconoscimento",
        component: MLabel,
        className: "col-md-12 pt-2 pb-0 mb-0",
      },
      {
        id: "rinunciaRiconoscimentoFile",
        field: "document",
        component: MFile,
        value: this.props.enrollmentId,
        config: {
          endPoint: "/enrollment/attachment-file",
          fieldName: "document",
          maxFiles: 1,
          minFiles: 1,
          accept: ".pdf,.doc,.docx,.p7m,.xml",
          code: "rinunciaRiconoscimento",
          mandatory: true,
        },
        className: "col-md-12",
      },
    ],
    [
      {
        field: "optionalInfo",
        label: "Informazioni facoltative:",
        infoText:
          "Informazioni per la verifica dei dati ex articolo 15, comma 1, punto e della legge 183/2011. Recapiti della segreteria competente.",
        component: MLabel,
        className: "col-md-12",
      },
    ],
    [
      {
        id: "contactName6",
        field: "contactName",
        label: "Denominazione",
        component: MInput,
        type: "text",
        className: "col-md-12",
      },
    ],
    [
      {
        id: "contactPhone6",
        field: "contactPhone",
        label: "Telefono",
        component: MInput,
        type: "text",
        className: "col-md-6",
      },
      {
        id: "contactFax6",
        field: "contactFax",
        label: "Fax",
        component: MInput,
        type: "text",
        className: "col-md-6",
      },
    ],
    [
      {
        id: "contactEmail6",
        field: "contactEmail",
        label: "Email",
        component: MInput,
        type: "text",
        className: "col-md-6",
      },
      {
        id: "contactPec6",
        field: "contactPec",
        label: "Pec",
        component: MInput,
        type: "text",
        className: "col-md-6",
      },
    ],
  ];

  ERROR_MESSAGES = {
    dataPresentazioneDomanda: "Inserire una data valida",
    istitution: "Dato obbligatorio",
    numProtocollo: "Dato obbligatorio",
  };

  validation = {
    dataPresentazioneDomanda: (value) => this.validateDataRinuncia(value),
    istitution: (value) => value !== "",
    numProtocollo: (value) => value !== "",
  };

  validateDataRinuncia = (value) => {
    if (value === "") {
      return false;
    }
    let regex = /^\d{4}-\d{2}-\d{2}$/;

    if (!value.match(regex)) {
      return false;
    }
    const date = new Date(value);

    if (Number.isNaN(date.getTime())) {
      return false;
    }
    const [year, month, day] = value.split("-").map(Number);

    if (month > 12) {
      return false;
    }
    if (day > 31) {
      return false;
    }

    const noFuture = dateHelper.noFuture(value);
    if (noFuture === false) {
      return false;
    }

    //data limite 16 marzo 2026
    const maxDate = new Date("2026-03-16");
    if (date > maxDate) {
      this.setState({ validationError: "La data non può essere successiva al 16 marzo 2026" });
      return false;
    }

    const currentYear = new Date().getFullYear();
    if (year < currentYear - 70 || year > currentYear) {
      return false;
    }

    return true;
  };

  componentDidMount() {
    const { defaultPayload, enrollmentId } = this.props;

    if (defaultPayload && defaultPayload.length > 0) {
      const rinuncia = defaultPayload[0];
      this.setState({
        ...rinuncia,
        document: enrollmentId,
        defaultValues: { ...rinuncia },
      });
    } else {
      this.setState({
        document: enrollmentId,
        defaultValues: { ...this.state.defaultValues },
      });
    }
  }

  onSubmit = () => {
    const isValid = this.checkValidation();
    return isValid;
  };

  getPayload = () => {
    this.payload = payloadBuilder(this.state);
    this.payload.qualificationType = "RinunciaRiconoscimento";
    this.payload.extCode = "Title16_RinunciaRiconoscimento";
    this.payload.qualificationCode = "title16";
    this.payload.template = "Title16_RinunciaRiconoscimento";
    return this.payload;
  };

  //--- ---

  render() {
    const { defaultValues, validationError } = this.state;
    const { code } = this.renderFields(this.FIELDS_GROUP, defaultValues, true);

    return (
      <>
        <form className="user mt-3">{code}</form>
        {validationError && <div className="text-danger">{validationError}</div>}
      </>
    );
  }
}
